import {Component, forwardRef, Input, OnInit, ViewChild,} from '@angular/core';
import {Subject} from 'rxjs';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CountryAndTimezoneService} from '@app/shared/services/country-timezone/country-and-timezone.service';
import {MessageTranslateService} from '@shared/services';

@Component({
  selector: 'app-timezone-select',
  templateUrl: './timezone-select.component.html',
  styleUrls: ['./timezone-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimezoneSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class TimezoneSelectComponent implements OnInit, ControlValueAccessor {

  readonly MAX_ITEMS = 3;
  selectedTimezones: string[];

  @Input() id: string;
  @Input() required: boolean;
  @Input() class: string;
  @Input() multiSelect = false;
  @Input() placeholder: string;
  @Input() country = this.countryTimezoneService.COUNTRY_AUSTRALIA;

  loading: boolean;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  @ViewChild('aceSelect', { static: true })
  private aceSelect: AceSelectComponent;

  private onChange: (_) => void = (_) => {};
  private onTouched: () => void = () => {};

  constructor(private translateService: MessageTranslateService,
              private countryTimezoneService: CountryAndTimezoneService) {
  }

  ngOnInit() {
    if (this.placeholder === undefined) {
      this.placeholder = this.translateService.instant('Select Time Zone');
    }

    this.aceSelect.registerOnChange(this.aceSelectChange);
    this.aceSelect.registerOnTouched(this.aceSelectTouched);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  aceSelectChange = (selected: string | string[]) => {
    this.updateSelectedValue(selected);
    this.onChange(selected);
  }

  aceSelectTouched = () => {
    this.onTouched();
  }

  writeValue(value: any): void {
    this.updateSelectedValue(value);
    this.aceSelect.writeValue(value);
  }

  compareFn(a: string, b: string): boolean {
    return a === b;
  }

  private updateSelectedValue(value: string | string[]): void {
    if (value) {
      if (Array.isArray(value)) {
        this.selectedTimezones = value;
      } else {
        this.selectedTimezones = [value];
      }
    } else {
      this.selectedTimezones = <string[]>value;
    }
  }

  get timezones(): string[] {
    return this.countryTimezoneService.TIMEZONES_BY_COUNTRY.get(this.country);
  }

}
